export var LoadingStatus;
(function (LoadingStatus) {
    LoadingStatus[LoadingStatus["None"] = 0] = "None";
    LoadingStatus[LoadingStatus["Loading"] = 1] = "Loading";
    LoadingStatus[LoadingStatus["Complete"] = 2] = "Complete";
    LoadingStatus[LoadingStatus["Error"] = 3] = "Error";
})(LoadingStatus || (LoadingStatus = {}));
export class FormValidationErrors {
    constructor(params) {
        this.getAllValidationErrors = (fieldName) => {
            let errorString = '';
            errorString += this.getClientValidationErrors(fieldName);
            const apiErrors = this.getApiValidationErrors(fieldName);
            if (apiErrors) {
                errorString += ` ${apiErrors}`;
            }
            return errorString;
        };
        this.getApiValidationErrors = (fieldName) => {
            const existingApiError = this.apiValidationErrors.find((e) => e.field === fieldName);
            if (existingApiError) {
                return existingApiError.validationErrors.join(' ');
            }
            return '';
        };
        this.getClientValidationErrors = (fieldName) => {
            let errorString = '';
            const existingClientError = this.clientValidationErrors.find((e) => e.field === fieldName);
            if (existingClientError) {
                errorString += existingClientError.validationErrors.join(' ');
            }
            if (errorString.length > 0) {
                return errorString;
            }
            return '';
        };
        this.clientValidationErrors = (params === null || params === void 0 ? void 0 : params.clientValidationErrors) || [];
        this.apiValidationErrors = (params === null || params === void 0 ? void 0 : params.apiValidationErrors) || [];
    }
}
export class FormValidation {
    constructor(params) {
        this.validate = (entity) => {
            this.validateClient(entity);
            this.setAllApiValidationErrors(this.apiValidation);
            return new FormValidationErrors({
                clientValidationErrors: this.clientValidationErrors,
                apiValidationErrors: this.apiValidationErrors,
            });
        };
        this.setFieldAsDirty = (fieldName) => {
            const existingDirty = this.dirtyFields.find((e) => e.field === fieldName);
            if (existingDirty) {
                existingDirty.isDirty = true;
            }
            else {
                this.dirtyFields.push({
                    field: fieldName,
                    isDirty: true,
                });
            }
            this.dirtyFields = [...this.dirtyFields];
        };
        this.setAllAsDirty = () => {
            this.allAreDirty = true;
        };
        this.validateClient = (entity) => {
            this.clientValidationErrors = [];
            if (!this.yupValidator) {
                return true;
            }
            try {
                this.yupValidator.validateSync(entity, { abortEarly: false });
            }
            catch (errors) {
                errors.inner.forEach((err) => {
                    const existingDirty = this.dirtyFields.find((e) => e.field === err.path);
                    if (this.allAreDirty || (existingDirty && existingDirty.isDirty)) {
                        const existingError = this.clientValidationErrors.find((e) => e.field === err.path);
                        if (existingError) {
                            existingError.validationErrors.push(err.message);
                        }
                        else {
                            this.clientValidationErrors.push({
                                field: err.path,
                                entity: errors.value,
                                validationErrors: [err.message],
                            });
                        }
                    }
                });
                return false;
            }
            return true;
        };
        this.setApiValidationFieldErrors = (fieldName, errors) => {
            const existingErrorIndex = this.apiValidationErrors.findIndex((e) => e.field === fieldName);
            if (existingErrorIndex > -1) {
                this.apiValidationErrors = this.apiValidationErrors.splice(existingErrorIndex, 1);
            }
            if (errors && errors.length) {
                const newError = {
                    field: fieldName,
                    validationErrors: new Array(),
                };
                errors.forEach((error) => {
                    newError.validationErrors.push(error);
                });
                this.apiValidationErrors.push(newError);
            }
        };
        this.setAllApiValidationErrors = (apiValidationErrors) => {
            this.apiValidationErrors = [];
            if (apiValidationErrors) {
                apiValidationErrors.forEach((error) => {
                    this.setApiValidationFieldErrors(error.field, error.errors || []);
                });
            }
        };
        this.clientValidationErrors = [];
        this.apiValidationErrors = [];
        this.apiValidation = params === null || params === void 0 ? void 0 : params.apiValidation;
        this.clientValidators = params === null || params === void 0 ? void 0 : params.clientValidators;
        this.objectToValidate = params === null || params === void 0 ? void 0 : params.objectToValidate;
        this.requiredProps = params === null || params === void 0 ? void 0 : params.requiredProps;
        this.yupValidator = params === null || params === void 0 ? void 0 : params.yupValidator;
        this.dirtyFields = [];
        this.allAreDirty = false;
    }
}
//# sourceMappingURL=formValidation.js.map